import React, { useState } from "react";
import { Form, Upload, Icon, message, Input } from "antd";
import styled from "styled-components";
import { FormattedMessage, useIntl } from "react-intl";
import ImgCrop from "../ImgCrop";

import { DOMAIN } from "../../config";

class AppDetailForm extends React.Component {}

AppDetailForm = Form.create({
  name: "AppDetailForm",
  onValuesChange: (props, changedValues, allValues) => props.handleChanged()
})(function(props) {
  const [ImageUrl, setImageUrl] = useState();
  const [Loading, setLoading] = useState(false);

  const Intl = useIntl();

  const { customstyle, defaultValue } = props;
  const { getFieldDecorator, getFieldError } = props.form;
  const appNameError = getFieldError("appName");
  const homepageError = getFieldError("homepage");
  const descriptionError = getFieldError("description");

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      callback(reader.result);
    });
    reader.readAsDataURL(img);
  };
  const handleUploadChange = info => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, ImageUrl => {
        setImageUrl(ImageUrl);
        setLoading(true);
      });
    }
  };
  // 图片分辨率判断
  // const util = (file, width = 0, height = width) =>
  //   new Promise(function(resolve, reject) {
  //     const reader = new FileReader();
  //     const image = new Image();

  //     reader.addEventListener("load", e => (image.src = e.target.result));
  //     image.addEventListener("load", () => {
  //       if (image.width === width && image.height === height) {
  //         return resolve();
  //       } else {
  //         message.error(Intl.formatMessage({ id: "message_upload300x300" }));
  //         return reject();
  //       }
  //     });
  //     reader.readAsDataURL(file);
  //   });
  // 图片上传判断
  function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error(Intl.formatMessage({ id: "message_uploadType" }));
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error(Intl.formatMessage({ id: "message_uploadSize" }));
    }
    return isJpgOrPng && isLt2M;
  }

  return (
    <AppDetailFormWrapper layout="horizontal" customstyle={customstyle}>
      <Form.Item
        label={
          <span className="customLabel">
            <FormattedMessage id="appSetting_appIcon" />
          </span>
        }
        colon={false}
      >
        <ImgCrop>
          <Upload
            name="file"
            listType="picture-card"
            showUploadList={false}
            action={`//${DOMAIN}/api/v1/oauthapp/${defaultValue.id}/icon`}
            beforeUpload={beforeUpload}
            onChange={handleUploadChange}
            withCredentials={true}
          >
            {ImageUrl || defaultValue.icon ? (
              <img src={ImageUrl || defaultValue.icon} alt="icon" style={{ width: "100%" }} />
            ) : (
              <div>
                <Icon type={Loading ? "loading" : "plus"} />
                <div className="ant-upload-text">
                  {Intl.formatMessage({ id: "appSetting_upload" })}
                </div>
              </div>
            )}
          </Upload>
        </ImgCrop>
      </Form.Item>
      <Form.Item
        validateStatus={appNameError ? "error" : ""}
        help={appNameError || ""}
        label={
          <span className="customLabel">
            <FormattedMessage id="appSetting_appName" />
          </span>
        }
        colon={false}
      >
        {getFieldDecorator("appName", {
          initialValue: defaultValue.appName,
          validateTrigger: "onBlur",
          rules: [
            {
              required: true,
              message: <FormattedMessage key="tip_appNamerequired" id="tip_appNamerequired" />
            },
            {
              max: 64,
              message: <FormattedMessage key="tip_appNameMax64" id="tip_appNameMax64" />
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item
        validateStatus={homepageError ? "error" : ""}
        help={homepageError || ""}
        label={
          <span className="customLabel">
            <FormattedMessage id="appSetting_appServicesURL" />
          </span>
        }
        colon={false}
      >
        {getFieldDecorator("homepage", {
          initialValue: defaultValue.homepage,
          validateTrigger: "onBlur",
          rules: [
            {
              max: 256,
              message: (
                <FormattedMessage key="tip_appServicesURLMax64" id="tip_appServicesURLMax64" />
              )
            },
            {
              type: "url",
              message: <FormattedMessage key="tip_URL" id="tip_URL" />
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item
        validateStatus={descriptionError ? "error" : ""}
        help={descriptionError || ""}
        label={
          <span className="customLabel">
            <FormattedMessage id="appSetting_desctiption" />
          </span>
        }
        colon={false}
      >
        {getFieldDecorator("description", {
          initialValue: defaultValue.description,
          validateTrigger: "onBlur",
          rules: [
            {
              max: 1000,
              message: <FormattedMessage key="tip_descriptionMax1000" id="tip_descriptionMax1000" />
            }
          ]
        })(<Input.TextArea rows={4} />)}
      </Form.Item>
    </AppDetailFormWrapper>
  );
});

export default AppDetailForm;

const AppDetailFormWrapper = styled(Form)`
  ${props => props.customstyle}
`;
